import { render } from "./staffoperationtargetmodel.vue?vue&type=template&id=5fde28eb"
import script from "./staffoperationtargetmodel.vue?vue&type=script&lang=ts"
export * from "./staffoperationtargetmodel.vue?vue&type=script&lang=ts"
script.render = render

export default script